import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfCategories } from '../../categorySchema'

export default categories => {
    const categoriesData = pathOr([], ['_embedded', 'hotels24Categories'], categories)
    return { ...normalize(categoriesData, arrayOfCategories) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/h24Parsers/h24Categories.js